<template>
<md-card>
    <header-form title="EDITAR DE USUÁRIOS" :rota="{name: 'usuarioRead'}" tooltip="Lista de Usuários" />

    <form @submit.prevent="update">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="usuario.nome" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field>
                        <label>APELIDO</label>
                        <md-input v-model="usuario.apelido" type="text" class="uppercase"> </md-input>
                    </md-field>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.usuario }">
                        <label>USUARIO</label>
                        <md-input v-model="usuario.usuario" type="text" class="uppercase"> </md-input>

                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.usuario">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.usuario" class="validErro"> {{ errors.usuario[0] }}</div>
                </div>

                <div class="md-layout-item md-size-25 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.celular }">
                        <label>CELULAR</label>
                        <md-input v-model="usuario.celular" type="text" v-mask="['(##) ####-####','(##) #####-####']"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.celular">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.celular" class="validErro"> {{ errors.celular[0] }}</div>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-warning md-round">
                <span class="md-label">
                    <md-icon class="material-icons">edit</md-icon>
                </span>EDITAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            usuario: {},
            errors: {}
        }
    },

    created() {
        this.getUsuario()
    },

    mixins: [Notify],

    methods: {

        getUsuario() {
            this.$http.get(this.$urlAPI + 'usuarios/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.usuario = response.data.dados[0];
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        update() {
            this.$http.put(this.$urlAPI + 'usuarios/' + this.usuario.id, this.usuario)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push('/usuarios');
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                        let erros = ''
                        for (let erro of Object.values(response.data.errors)) {
                            erros += "<li>" + erro + "</li>";
                        }
                        this.danger("<ul>" + erros + "</ul>")
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>

